import React from 'react';

export interface JsonDownloaderProps {
  jsonData: any;
  onReset: () => void;
}

const JsonDownloader: React.FC<JsonDownloaderProps> = ({ jsonData, onReset }) => {
  const handleDownload = () => {
    const blob = new Blob([JSON.stringify(jsonData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'menu.json';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-6 rounded-2xl shadow-lg bg-[#1e2a3a] text-white w-full max-w-xl mx-auto mt-10">
      <h2 className="text-xl font-semibold mb-4 text-[#d0e4ff] text-center">
        JSON Download
      </h2>

      <div className="flex justify-center gap-4 mb-4">
        <button
          onClick={handleDownload}
          className="bg-[#37597e] hover:bg-[#2f4d6d] text-white px-5 py-2 rounded-lg transition font-semibold"
        >
          Download JSON
        </button>
        <button
          onClick={onReset}
          className="bg-[#2c3e50] hover:bg-[#243746] text-white px-5 py-2 rounded-lg transition font-semibold"
        >
          Start Over
        </button>
      </div>

      <pre className="bg-[#2f4158] p-4 rounded-xl max-h-64 overflow-auto text-xs text-[#c5d7ef]">
        {JSON.stringify(jsonData, null, 2)}
      </pre>
    </div>
  );
};

export default JsonDownloader;
